import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

/**
 * OwnerDashboardMenu - Navigation menu for owner-only dashboards
 * 
 * Links to:
 * - Onboarding Dashboard
 * - Active Users Dashboard
 * - Behavior Analytics Dashboard
 * - Backup Dashboard
 * - Club Creator
 * - Global Ticker (NEW)
 */

const OwnerDashboardMenu = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const dashboards = [
    {
      id: 'onboarding',
      name: 'Onboarding',
      path: '/owner-9x7kq2m',
      icon: '📊',
      description: 'Track club signup → allocation journey'
    },
    {
      id: 'active-users',
      name: 'Active Users',
      path: '/owner-active-users',
      icon: '👥',
      description: 'Live user activity & engagement'
    },
    {
      id: 'behavior-analytics',
      name: 'Behavior Analytics',
      path: '/owner-behavior-8n4p',
      icon: '📀',
      description: 'User flows, patterns & insights'
    },
    {
      id: 'backups',
      name: 'Backups',
      path: '/owner-backup-7k3m',
      icon: '💾',
      description: 'Club data backup management'
    },
    {
      id: 'club-creator',
      name: 'Club Creator',
      path: '/owner-club-creator',
      icon: '🏟️',
      description: 'Pre-create clubs for demos with invite codes'
    },
    {
      id: 'ticker',
      name: 'Global Ticker',
      path: '/owner-ticker',
      icon: '📺',
      description: 'Broadcast messages to all users'
    }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h1 style={styles.title}>🔒 Owner Dashboards</h1>
        <p style={styles.subtitle}>Internal analytics & management tools</p>
      </div>

      <div style={styles.grid}>
        {dashboards.map((dashboard) => (
          <button
            key={dashboard.id}
            onClick={() => navigate(dashboard.path)}
            style={{
              ...styles.card,
              ...(isActive(dashboard.path) ? styles.cardActive : {})
            }}
          >
            <div style={styles.cardIcon}>{dashboard.icon}</div>
            <div style={styles.cardContent}>
              <h3 style={styles.cardTitle}>{dashboard.name}</h3>
              <p style={styles.cardDescription}>{dashboard.description}</p>
            </div>
            <div style={styles.cardArrow}>→</div>
          </button>
        ))}
      </div>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '800px',
    margin: '0 auto',
    padding: '32px 24px',
  },
  header: {
    marginBottom: '32px',
    textAlign: 'center',
  },
  title: {
    fontSize: '28px',
    fontWeight: '700',
    color: '#243665',
    margin: '0 0 8px 0',
  },
  subtitle: {
    fontSize: '14px',
    color: '#64748b',
    margin: 0,
  },
  grid: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  card: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    padding: '20px 24px',
    backgroundColor: 'white',
    border: '1px solid #e5e7eb',
    borderRadius: '12px',
    cursor: 'pointer',
    textAlign: 'left',
    transition: 'all 0.2s ease',
    boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
  },
  cardActive: {
    borderColor: '#243665',
    backgroundColor: '#f8fafc',
  },
  cardIcon: {
    fontSize: '32px',
    width: '48px',
    height: '48px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f1f5f9',
    borderRadius: '10px',
  },
  cardContent: {
    flex: 1,
  },
  cardTitle: {
    fontSize: '18px',
    fontWeight: '600',
    color: '#1e293b',
    margin: '0 0 4px 0',
  },
  cardDescription: {
    fontSize: '14px',
    color: '#64748b',
    margin: 0,
  },
  cardArrow: {
    fontSize: '20px',
    color: '#94a3b8',
  },
};

export default OwnerDashboardMenu;
